/* Modus & Mood: identity for the custom pixel (6 Oct 2026).
   When a shopper gives an email or phone on the site (welcome popup, footer sign-up, product page sign-up,
   newsletter banner, back in stock, reminders) or is signed in, the values are normalised and hashed here
   (SHA-256, which Meta accepts pre-hashed), kept in this browser, and announced to the custom pixel as the
   event mm_identify with em, ph and external_id. The custom pixel (docs/custom-pixel-mm-wishlist.js v7)
   passes them to Meta's advanced matching for the events it sends. Nothing unhashed is stored.
   external_id is the Shopify customer id when signed in, otherwise a stable random id for this browser.
   Published only when the shopper has allowed marketing cookies; Shopify gates the pixel by the same consent. */
(function () {
  var KEY = 'mmIdentity';
  var EID_KEY = 'mmExternalId';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function externalId(customerId) {
    if (customerId) return String(customerId);
    var id = '';
    try { id = localStorage.getItem(EID_KEY) || ''; } catch (e) {}
    if (!id) {
      id = 'mm-' + ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
      });
      try { localStorage.setItem(EID_KEY, id); } catch (e) {}
    }
    return id;
  }
  function sha256(text) {
    if (!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    });
  }
  function normEmail(v) { return String(v || '').trim().toLowerCase(); }
  function normPhone(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (!d) return '';
    if (d.length === 10) d = '91' + d;           /* an Indian number typed without the country code */
    if (d.length === 11 && d.charAt(0) === '0') d = '91' + d.slice(1);
    return d.length >= 11 ? d : '';
  }
  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.marketingAllowed === 'function') return api.marketingAllowed() !== false;
    } catch (e) {}
    return true;
  }
  function publish() {
    var id = read();
    if (!(id.em || id.ph)) return;
    if (!allowed()) return;
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('mm_identify', { em: id.em || '', ph: id.ph || '', external_id: id.eid || externalId() });
    }
  }
  var API = {
    /* set({ email, phone, customerId, emHashed }) : hashes, stores, announces */
    set: function (o) {
      o = o || {};
      var cur = read();
      var jobs = [];
      if (o.emHashed && /^[0-9a-f]{64}$/.test(o.emHashed)) cur.em = o.emHashed;
      else if (normEmail(o.email)) jobs.push(sha256(normEmail(o.email)).then(function (h) { if (h) cur.em = h; }));
      if (normPhone(o.phone)) jobs.push(sha256(normPhone(o.phone)).then(function (h) { if (h) cur.ph = h; }));
      if (o.customerId) cur.eid = String(o.customerId);
      if (!cur.eid) cur.eid = externalId();
      return Promise.all(jobs).then(function () { cur.at = Date.now(); write(cur); publish(); return cur; });
    },
    get: read,
    publish: publish
  };
  window.MMIdentity = API;

  /* Signed-in customer: data from the script tag (email already hashed by Liquid) */
  var me = document.currentScript;
  if (me && me.dataset.customerId) {
    API.set({ customerId: me.dataset.customerId, emHashed: me.dataset.em || '', phone: me.dataset.ph || '' });
  } else {
    publish();
  }

  /* Any form on the site with an email or phone field: capture on submit (the forms post normally) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var em = form.querySelector('input[type="email"], input[name="contact[email]"], input[name="customer[email]"]');
    var ph = form.querySelector('input[type="tel"], input[name="contact[phone]"]');
    var email = em && em.value, phone = ph && ph.value;
    if (!(normEmail(email) || normPhone(phone))) return;
    API.set({ email: email, phone: phone });
  }, true);
})();
